import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';

import { MenusService } from '../../menus/menus.service';

import { BotMenu } from 'src/models/IBotMenu';
import { MENUS } from 'src/models/AppSections';
import { PrivilegesName } from 'src/models/privileges';
import { DashboardService } from '../../dashboard.service';
import { UISections } from 'src/models/constants';

@Component({
  selector: 'app-menus-pool',
  templateUrl: './menus-pool.component.html',
  styleUrls: ['./menus-pool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenusPoolComponent {
  @Output() cancelNotfiy = new EventEmitter<boolean>();
  @Output() selectMenuNotfiy = new EventEmitter<BotMenu>();
  currentSelectMessage: BotMenu = null;
  menuFet = MENUS;
  privilegesName: typeof PrivilegesName = PrivilegesName;

  constructor(
    public dashboardService: DashboardService,
    public menusService: MenusService
  ) {
    menusService.resetPaging();
  }

  cancelEvent() {
    this.cancelNotfiy.emit(true);
  }

  setSelectMessage(message: BotMenu) {
    this.currentSelectMessage = { ...message };
  }
  resetSelectMessage() {
    this.currentSelectMessage = null;
  }
  insertEvent() {
    this.selectMenuNotfiy.emit(this.currentSelectMessage);
  }

  TrackByFunction(index, item: BotMenu) {
    return item.id;
  }

  createNewItem() {
    this.dashboardService.setSection(UISections.MENUS);
    this.menusService.selectMenu(null);
  }
}
